module.exports = __webpack_public_path__ + "static/media/14.8ff7e734.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/14.png
// module id = 1344
// module chunks = 0